import Client from "@atlassian/feature-gate-js-client";
const FeatureGates = Client;
export default FeatureGates;
